import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components/macro';

import ModalContainer from 'components/modal-views/container';
import GlobalAlert from 'components/common/global-alert/global-alert';

import {
  selectAccountId,
  actions as activeAccountActions
} from 'redux/slices/account';

import { actions as tokensActions } from 'redux/slices/tokens';
const { fetchTokens, fetchPlantTokens } = tokensActions;
const { actionAccountCheckBalance, actionAccountLoading, actionAccountSetStorageBalance } =
  activeAccountActions;
import { baseTheme } from 'site-settings/site-theme/base-theme';
import { useAppDispatch, useAppSelector } from 'redux/use-hooks';
import { GlobalStyle } from 'assets/styles/global.style';
import routes from './routes';

import config from 'config';
const { OPN_CONTRACT, OCC_CONTRACT,USDC_CONTRACT } = config;

const Routing = () => {
  const routing = useRoutes(routes);
  const accountId = useAppSelector(selectAccountId);
  const dispatch = useAppDispatch();

  useEffect(() => {
    (async function () {
      if (accountId) {
        dispatch(fetchTokens({ accountId }));
        dispatch(fetchPlantTokens({ accountId }));

        await Promise.all(
          [OPN_CONTRACT, OCC_CONTRACT, USDC_CONTRACT].map(async (contractName) => {
            await dispatch(
              actionAccountCheckBalance({ contractName, accountId })
            );
            await dispatch(
              actionAccountSetStorageBalance({ contractName, accountId })
            );
          })
        );
        dispatch(actionAccountLoading());
      }
    })();
  }, [accountId]);

  return (
    <ThemeProvider theme={baseTheme}>
      <div className="site-wrapper">{routing}</div>
      <ModalContainer />
      <GlobalAlert />
      <GlobalStyle />
    </ThemeProvider>
  );
};

export default Routing;
